/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx'
import { useRouter } from 'next/router'
import { ReactNode, useEffect } from 'react'
import { useQuery } from 'react-query'
import { INFO_CUSTOMER } from '~src/api'
import { graphQLClient } from '~src/api/graphql'
import { BreadcrumbHead } from '~src/components/global/Layout/BreadcrumHead'
import styles from './AccountInfo.module.scss'
import { useCookies } from 'react-cookie'
import React, { createContext, useContext } from 'react'
import FormUploadSingle from '../../FormControls/FormUploadSingle'
import { TChangeInfoCustomer } from '~src/types/authenticate'
import { useForm } from 'react-hook-form'
import Link from 'next/link'

export type TCustomerInfo = {
  profile_picture?: string
  lastname?: string
  firstname?: string
  email?: string
  date_of_birth?: string
  phone_number?: string
  [key: string]: any
}

export const AccountContext = createContext<TCustomerInfo | undefined>(undefined)

export const useAccountContext = () => useContext(AccountContext)

export const AccountLayout = ({ children }: { children: ReactNode }) => {
  const router = useRouter()
  const [cookies, setCookie, removeCookie] = useCookies(['token'])

  const { data: dataInfoCustomer, refetch } = useQuery({
    queryKey: ['getInfoCustomerOrder'],
    queryFn: async () => {
      const data = (await graphQLClient.request(INFO_CUSTOMER, {
        customer: {
          orders: {
            // filter: {
            //   number: {
            //     eq: !!router.query?.search ? router.query?.search : ''
            //   }
            // },
            currentPage: !!router.query?.currentPage ? parseInt(`${router.query?.currentPage}`) : 1,
          },
        },
      })) as {
        customer: any
      }
      return data?.customer
    },
    cacheTime: Infinity,
  })

  const { setValue, watch } = useForm<TChangeInfoCustomer>({
    defaultValues: {},
  })

  useEffect(() => {
    if (dataInfoCustomer?.profile_picture) {
      setValue('avatar', { url: dataInfoCustomer?.profile_picture })
    }
  }, [dataInfoCustomer?.profile_picture, setValue])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!!localStorage?.getItem('token')) {
        refetch()
      }
    }
  }, [])

  const avatarValue = watch('avatar')?.url

  const tabs = [
    {
      name: 'Thông tin tài khoản',
      icon: '/icons/user-info.svg',
      route: '/account',
    },
    {
      name: 'Sổ địa chỉ',
      icon: '/icons/history-step.svg',
      route: '/account/address',
    },
    {
      name: 'Thay đổi mật khẩu',
      icon: '/icons/padlock.svg',
      route: '/account/change-password',
    },
    {
      name: 'Lịch sử đơn hàng',
      icon: '/icons/order-history.svg',
      route: '/account/orders',
    },
  ]

  return (
    <AccountContext.Provider value={avatarValue}>
      <div className={clsx(styles.accountContainer, 'sticky-profile')}>
        <BreadcrumbHead />
        <div className={clsx(styles.accountBg)}>
          <div className={clsx(styles.accountBox)}>
            <MenuProfileMobile />
            <div className={clsx(styles.accountBoxLeft, 'max-lg:hidden')}>
              <div className={clsx(styles.boxLeftHead)}>
                <FormUploadSingle title={'Chọn ảnh'} setValue={setValue} watch={watch} />
                <div>
                  <p>
                    {dataInfoCustomer?.lastname} {dataInfoCustomer?.firstname}
                  </p>
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      localStorage.removeItem('token')
                      removeCookie('token', { path: '/' })
                      localStorage.removeItem('loginSocial')
                      localStorage.removeItem('cartId')
                      window.location.replace(`${window.location.origin}/login`)
                    }}
                  >
                    Đăng xuất
                  </span>
                </div>
              </div>
              <ul>
                {tabs.map((item) => (
                  <li
                    key={item.route}
                    className={clsx(
                      `${
                        item.route === router.pathname ||
                        (item.route === '/account/orders' && router.pathname?.includes(item.route))
                          ? styles.active
                          : ''
                      }`
                    )}
                    onClick={() => router.push(item.route)}
                  >
                    <img src={item.icon} alt="" />
                    <p>{item.name}</p>
                  </li>
                ))}
              </ul>
            </div>

            {children}
          </div>
        </div>
      </div>
    </AccountContext.Provider>
  )
}

const MenuProfileMobile = () => {
  const navItems = [
    { href: '/account', label: 'Tài khoản', icon: '/icons/user-info.svg' },
    { href: '/account/address', label: 'Địa chỉ', icon: '/icons/history-step.svg' },
    { href: '/account/change-password', label: 'Đổi mật khẩu', icon: '/icons/padlock.svg' },
    { href: '/account/orders', label: 'Đơn hàng', icon: '/icons/order-history.svg' },
  ]

  const pathname = useRouter().pathname

  return (
    <div className="sticky max-lg:block hidden top-[7rem] left-0 z-[100]  w-full overflow-hidden  bg-[#007134] md:hidden">
      <div className="flex justify-between">
        {navItems.map((item) => (
          <Link
            key={item.href}
            href={item.href}
            className={clsx(
              'profile-menu-item gap-y-[0.4rem] flex flex-1 flex-col items-center justify-center py-3 text-white',
              pathname === item.href && 'active'
            )}
          >
            <a
              href=""
              className={clsx(
                'profile-menu-item flex flex-1 flex-col items-center gap-y-[0.2rem] justify-center py-3 text-white',
                pathname === item.href && 'active'
              )}
            >
              <img
                src={item.icon}
                alt={item.label}
                width={20}
                height={20}
                className="w-[1.5rem] h-[1.5rem]"
              />
              <span className="text-[12px]">{item.label}</span>
            </a>
          </Link>
        ))}
      </div>
    </div>
  )
}
